<script setup lang="ts">
import type { ContentHeadingProps } from '@fondof-ui/components/content/types'
import type { HTMLAttributeClass } from '@fondof-ui/types'

const props = withDefaults(
  defineProps<ContentHeadingProps & HTMLAttributeClass>(),
  {
    is: 'h2',
  }
)
</script>

<template>
  <component
    :is="props.is"
    v-if="$slots.default"
    :class="props.class"
  >
    <slot />
  </component>
</template>
